import React from 'react';

const theme = '#5e4aee';

const FacebookLogo = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 72 72" {...props}>
      <path
        fill={theme}
        d="M54.74,50.94a2,2,0,0,1-2,2H43.36V38.75h4.77l.72-5.55H43.36V29.67c0-1.61.45-2.7,2.75-2.7H49V22a42.36,42.36,0,0,0-4.28-.21c-4.23,0-7.12,2.58-7.12,7.32V33.2H32.85v5.55h4.79V53H20.06a2,2,0,0,1-2-2V18.28a2,2,0,0,1,2-2H52.72a2,2,0,0,1,2,2Z"
      />
    </svg>
  );
};

export default FacebookLogo;
